import { useMutation } from '@apollo/react-hooks';
import { kmsClient } from 'api';
import { CREATE_FACEBOOK_IMPORT_REQUEST_MUTATION } from './createFacebookImportRequest.mutation';
import {
  CreateFacebookImportRequestMutation,
  CreateFacebookImportRequestMutationVariables
} from './__generated__/CreateFacebookImportRequestMutation';

interface MutationProps {
  onStart?: () => void;
  onCompleted?: () => void;
  onError: (errors: string[]) => void;
}

export function useCreateFacebookImportRequest({
  onStart,
  onCompleted,
  onError
}: MutationProps): [(variables: CreateFacebookImportRequestMutationVariables) => void, { loading: boolean }] {
  const [createFacebookImportRequest, { loading }] = useMutation<
    CreateFacebookImportRequestMutation,
    CreateFacebookImportRequestMutationVariables
  >(CREATE_FACEBOOK_IMPORT_REQUEST_MUTATION, {
    refetchQueries: ['FacebookImportRequestsQuery'],
    client: kmsClient,
    onCompleted: (data) => {
      if (data.createFacebookImportRequest?.errors?.length) {
        onError(data.createFacebookImportRequest.errors);
      } else if (onCompleted) {
        onCompleted();
      }
    },
    onError: (error) => onError([error.message])
  });

  return [
    (variables: CreateFacebookImportRequestMutationVariables) => {
      if (onStart) onStart();
      createFacebookImportRequest({ variables });
    },
    { loading }
  ];
}
